export default __webpack_public_path__ + "static/media/child_care.2cecbb15.svg";